import { DEFAULT_HUBSPOT_MEETING_LINK, JIM_HUBSPOT_STRATEGY_MEETING_LINK, YASH_HUBSPOT_MEETING_LINK } from './hubspot';

const STRATEGY_SESSION_MAPPING = {
  'support@getsaral.com': DEFAULT_HUBSPOT_MEETING_LINK,
  'yash@getsaral.com': YASH_HUBSPOT_MEETING_LINK,
  'jim.t@getsaral.com': JIM_HUBSPOT_STRATEGY_MEETING_LINK,
};

export { STRATEGY_SESSION_MAPPING };
